
const filterInt = function (value) {
  if(/^[-+]?([0-9]+|Infinity)$/.test(value))
    return Number(value);
  return NaN;
}

/**
 * Build a filter handler.
 *
 * @param {object} operation
 * @param {object} operation.parameters
 * @param {string} operation.url
 * @param {string} operation.url_absolute
 */
export default function ListFilter (operation) {
  const filters = {}
  operation.parameters.map((parameter) => {
    if (parameter.in === 'query') {
      filters[parameter.name] = parameter
    }
  })

  this.has = (name) => !!filters[name]

  this.defaultFilter = (undefinedOverride) => {
    undefinedOverride = undefinedOverride || {}
    const empty = {}
    for (let [parameterName, filter] of Object.entries(filters)) {
      if (filter.hasOwnProperty('default')) {
        empty[parameterName] = filter.default
      } else if (undefinedOverride.hasOwnProperty(parameterName)) {
        empty[parameterName] = undefinedOverride[parameterName]
      }
    }
    return empty
  }

  this.buildUrl = (values) => {
    const chunks = []
    // Append filters now.
    for (let [name, filter] of Object.entries(filters)) {
      if (values.hasOwnProperty(name)) {
        const value = values[name];
        if (value === undefined || value === null) {
          continue
        }
        // Skip default values.
        if (filter.hasOwnProperty('default') && value === filter.default) {
          continue
        }
        switch (filter.type) {
          case 'array':
            switch (filter.collectionFormat) {
              case 'multi':
                // FIXME: should encode the value as 'filter.items.type'
                chunks.push(value.map((value) => filter.name + '=' + value).join('&'))
                break;
              case 'csv':
                chunks.push(filter.name + '=' + value.join(','))
                break;
              case 'ssv':
                chunks.push(filter.name + '=' + value.join(' '))
                break;
              case 'tsv':
                chunks.push(filter.name + '=' + value.join('\t'))
                break;
              case 'pipes':
                chunks.push(filter.name + '=' + value.join('|'))
                break;
              default:
                console.error('unknown parameter array type', name, filter, value)
            }
            break;
          case 'string':
            // Ensure we have a proper uuid and no IRI.
            if (filter.format && filter.format.substr(0, 5) === 'uuid-') {
              chunks.push(filter.name + '=' + value.split('/').pop())
              break;
            }
            chunks.push(filter.name + '=' + value)
            break;
          case 'integer':
            if (!isNaN(value)) {
              chunks.push(filter.name + '=' + value)
            }
            break;
          default:
            console.error('unknown parameter type', name, filter, value)
        }
        // TODO:
      }
    }
    let url = operation.url
    if (chunks.length) {
      url += '?' + chunks.join('&');
    }
    return url
  }

  this.parseUrl = (url) => {
    const currentUrl = new URL(url, operation.url_absolute)
    const parameters = currentUrl.searchParams

    const parsed = {}
    for (let [name, filter] of Object.entries(filters)) {
      // const name = parameter.name
      const value = parameters.has(name) ? parameters.get(name) : (filter.hasOwnProperty('default') ? filter.default : undefined)
      if (parsed[name] === value) {
        continue;
      }
      switch (filter.type) {
        case 'array':
          switch (filter.collectionFormat) {
            case 'multi':
              parsed[name] = value
              break;
            default:
              console.error('unknown parameter array type', name, filter, value)
          }
          break;
        case 'string':
          parsed[name] = value
          break;
        case 'integer':
          parsed[name] = filterInt(value)
          break;
        default:
          console.error('unknown parameter type', name, filter, value)
      }
    }

    return parsed
  }
}
